<template>
  <div class="form-container">
    <DetailForm ref="commonForm" :id="virtualId" :bindData="formData" @setBasicInfoData="setBasicInfoData" />

    <Accessory
      v-if="uploadPermissionNameOne != ''&&(basicInfoData.projectInfoId||formData.projectInfoId)"
      :idname="uploadPermissionNameTwo"
      :fileMenuUrlname="uploadPermissionNameOne"
      :projectid="basicInfoData.projectInfoId||formData.projectInfoId"
      :dynamicId="virtualId"
      :upload="true"
      :permissionList="permissionList"
      :isPermission="true"
    />

    <InfoContainer
      :infoTitle="commentConfig['infoTitle']"
      :contentConfig="commentConfig['infoContent']"
    >
      <template #commentInfo>
        <!-- 会签意见区 -->
        <CommentBlock
          ref="commentBlock"
          :id="virtualId"
          @fileChange="fileChange"
        />
      </template>
    </InfoContainer>
    <div style="width: 100%; height: 40px"></div>
    <div class="bottom-container">
      <div class="button-container">
        <el-button type="primary" @click="savePage(false)">保存</el-button>
        <el-button
          type="primary"
          plain
          v-if="!formData.flowableId"
          @click="savePage(true)"
          >发起流程</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Accessory from "@/components/accessoriesother/accessoryFactor";
import InfoContainer from "@/components/infoContainer/infoContainer";
import DetailForm from "./components/form";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import {
  getInvestPocessName,
  addInvestLoan,
  queryInvestLoanDetail,
} from "@/api/factoring/factoring";
import workFlow from "@/mixins/workFlow";
export default {
  name: "AddInvestmentLoanDetailForm",
  mixins: [workFlow],
  data() {
    return {
      processKey: "bl_project_placement",
      detailFormUrl: "/factoring/InvestmentLoanManagement/investmentLoanDetail",
      virtualId: "",
      formData: {},
      basicInfoData: {
                projectInfoId:''
            },
    };
  },
  components: {
    DetailForm,
    Accessory,
    InfoContainer,
    CommentBlock,
  },
  async mounted() {
    if (this.$route.params.id && this.$route.params.id != "0") {
      this.virtualId = this.$route.params.id;
      this.queryInvestDetail(this.$route.params.id);
    } else {
      this.virtualId = await this.getVirtualID();
    }
    this.getBasicConfigData();
  },
  methods: {
    setBasicInfoData(data){
        this.basicInfoData=data
    },
    async queryInvestDetail(id) {
      let res = await queryInvestLoanDetail({ id });
      if (res.data.code == 200) {
        this.formData = res.data.data;
      }
    },

    async getBasicConfigData() {
      this.processDefinedId = await this.userQueryProcessDefinedId(
        this.processKey
      );
      // 获取当前流程文件上传列表权限 permissionList
      this.permissionList = await this.queryTaskUploadDetail(
        this.processDefinedId,
        "",
        true
      );
      // 设置流程表单路径
      this.queryProcessFormDetail(this.processDefinedId);
    },
    // 会签意见区附件设置
    fileChange(fileList) {
      let self = this;
      if (fileList.length > 0) {
        this.attchmentList = [];
        fileList.map((item) => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link,
          });
        });
      }
    },

    async savePage(startProcess) {
      let validRes = await this.$refs.commonForm.validForm();
      // console.info(validRes, 'validRessssssss')
      if (validRes) {
        this.submitForm(startProcess);
      }
    },

    async submitForm(startProcess) {
      let msg = this.$route.params.id ? "修改成功" : "新增成功";
      let { custId, reportId, name } = this.$refs.commonForm.$data.formOneData;
      let {
        rentId,
        contractId,
        netInvestAmount,
        bankId,
        otherCondition,
        rentDate,
        investCredit,
        isInvestCondition,
      } = this.$refs.commonForm.$data.formTwoData;
      let processInsId = "";
      let params = {
        id: this.virtualId,
        flowableId: "",
        accountingEntity: 1,
        custId,
        reportId,
        rentId,
        contractId,
        bankId,
        projectName: name,
        isInvestCondition,
        rentDate,
        thisInvestMoney: investCredit,
        cleanMoney: netInvestAmount,
        investOutlays: this.$refs.commonForm.$data.tableData,
        remarks: otherCondition,
      };
      let processNameRes = await getInvestPocessName(params);

      if (startProcess) {
        // 若存在会签意见附件 带入attchment字段
        let redirectInfo = {
          url: this.detailFormUrl,
          id: this.virtualId,
        };
        let processParams = {
          detailFormUrl: JSON.stringify(redirectInfo),
          processId: this.processDefinedId,
          comment: this.$refs.commentBlock.$data.opinionContent,
          attachmentList: this.attchmentList,
          processInstanceName: processNameRes.data.data.processInstanceName,
        };
        processInsId = await this.startWorkFlowProcess(processParams);
        // if(processInsId != '') params.flowableId = processInsId
      }
      if (processInsId != "") params.flowableId = processInsId;
      let res = await addInvestLoan(params);
      if (res.data.code == 200) {
        this.$router.push({
          path: `/factoring/InvestmentLoanManagement/investmentLoanDetail/${this.virtualId}`,
        });
        // 跳转到详情页
        this.$message({
          message: msg,
          type: "success",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form-container {
  padding: 10px 15px !important;
  .bottom-container {
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);
    .button-container {
      width: 78%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>